module.exports = __webpack_public_path__ + "img/itx-file-type-jpg.7b1a7b89.svg";